import { render, staticRenderFns } from "./ProductInfoCard.vue?vue&type=template&id=11a0a25a&"
import script from "./ProductInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProductInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
